import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=f56de982"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=f56de982&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f56de982')) {
      api.createRecord('f56de982', component.options)
    } else {
      api.reload('f56de982', component.options)
    }
    module.hot.accept("./PieChart.vue?vue&type=template&id=f56de982", function () {
      api.rerender('f56de982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/PieChart.vue"
export default component.exports